import React from "react";
import { HandleError, RadioGroup, TextField, DatePicker } from "../form";
import FormRow from "../FormRow";
import Addendums from "../Addendums";
import { ADDITIONAL_PETS } from "../../constants";

function FormUnitLease({ suffix }) {
  let defaultSuffix = "";
  if (suffix) {
    defaultSuffix = `${suffix}.`;
  }
  return (
    <>
      <FormRow label="Rate">
        <TextField name={`${defaultSuffix}rate.amount`} />
      </FormRow>
      <FormRow label="Late Fee">
        <TextField name={`${defaultSuffix}lateFee.amount`} />
      </FormRow>
      <FormRow label="Security Deposit">
        <TextField name={`${defaultSuffix}securityDeposit.amount`} />
      </FormRow>
      <FormRow label="Availability Date">
        <DatePicker name={`${defaultSuffix}availabilityDate`} />
        {/* <TextField name={`${defaultSuffix}availabilityDate`} /> */}
      </FormRow>
      <FormRow label="Additional Pets*">
        <RadioGroup list={ADDITIONAL_PETS} name={`${defaultSuffix}pets`} />
        <HandleError name={`${defaultSuffix}pets`} />
      </FormRow>
      <FormRow label="Addendums">
        <Addendums name={`${defaultSuffix}addendums`} />
      </FormRow>
    </>
  );
}

export default FormUnitLease;
